import { TableRowProps, Tr } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & TableRowProps;

export const CmTableBodyRow: React.FC<Props> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <Tr {...rest}>{children}</Tr>;
};
